import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SiteCtx = createContext(null);
const FALLBACK_PHONE = "505-596-0325";

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setSite(r.data)).catch(() => setSite({ error: true }));
  }, []);
  return <SiteCtx.Provider value={site}>{children}</SiteCtx.Provider>;
}

export function useSite() {
  const site = useContext(SiteCtx) || {};
  const phone = site.business?.phone || FALLBACK_PHONE;
  const digits = phone.replace(/\D/g, "");
  const e164 = `+1${digits.slice(-10)}`;
  return {
    site,
    loaded: !!site.business,
    phone,
    tel: `tel:${e164}`,
    sms: `sms:${e164}?&body=${encodeURIComponent("Hi One Punch Services, I'd like a quote. Here are photos of the job:")}`,
  };
}

export function useSeo(title, description) {
  useEffect(() => {
    const full = title ? `${title} | One Punch Services` : "One Punch Services | Handyman, Junk Removal & Cleanups in Albuquerque, Rio Rancho, Los Lunas, Corrales & Santa Fe";
    document.title = full;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement(sel.startsWith("link") ? "link" : "meta");
        const m = sel.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    const url = window.location.origin + window.location.pathname;
    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
    }
    set('meta[property="og:title"]', "content", full);
    set('meta[property="og:url"]', "content", url);
    set('link[rel="canonical"]', "href", url);
    window.scrollTo(0, 0);
  }, [title, description]);
}
